<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <v-toolbar flat>
        <v-toolbar-title>
          Invoices
        </v-toolbar-title>
        <v-spacer />

        <v-btn
          rounded
          outlined
          color="primary"
          :to="{ name: 'create-invoice', query: { customer: id }}"
        >
          <v-icon>add</v-icon>
          Create Invoice
        </v-btn>
      </v-toolbar>
      <base-stripe-table
        :headers="headers"
        :fetch-action="'listInvoices'"
        :fetch-query="{ customer: $route.params.id, expand: ['data.payment_intent'] }"
        :items-getter="'getInvoices'"
        :pagination-getter="'getInvoicePagination'"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              style="cursor: pointer"
              @click="goto(item)"
            >
              <td v-money="{ amount: item.total, currency: item.currency }" />
              <td class="text-center">

                <v-tooltip
                  bottom
                  color="white"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="_isInvoiceFromSubscription(item)"
                      small
                      v-on="on"
                      color="grey"
                    >
                      refresh
                    </v-icon>
                  </template>

                  <span class="black--text">This invoice was created by a recurring subscription</span>
                </v-tooltip>

              </td>
              <td>
                <invoice-status-chip
                  :invoice="item"
                />
              </td>
              <td>{{ item.number }}</td>
              <td v-date="item.due_date" />
              <td v-date="item.created" />
              <td />
            </tr>
          </tbody>
        </template>
      </base-stripe-table>
    </v-col>
  </v-row>
</template>
<script>
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import InvoiceStatusChip from "../Invoice/InvoiceStatusChip"
import { isInvoiceFromSubscription } from "../../services/stripe.service"

export default {
  components: {
    InvoiceStatusChip,
    BaseStripeTable
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Amount',
          align: 'left',
          sortable: false,
        },
        {
          text: '',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          sortable: false,
        },
        {
          text: 'Invoice Number',
          sortable: false,
        },
        {
          text: 'Due',
          sortable: false,
        },
        {
          text: 'Created',
          sortable: false,
        },
      ]
    }
  },
  methods: {
    _isInvoiceFromSubscription: val => isInvoiceFromSubscription(val),
    goto(item) {
      const { status, id } = item

      status === 'draft' && !isInvoiceFromSubscription(item)
        ? this.$router.push({ name: 'invoice-edit', params: { id } })
        : this.$router.push({ name: 'invoice-detail', params: { id } })
    }
  },
}
</script>
